import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const C = {
  pri: '#0a0e27',
  pri2: '#2952CC',
  accent: '#6382eb',
  accent2: '#4f6ef2',
  bg: '#f7f8fc',
  white: '#FFFFFF',
  text: '#444',
  muted: '#666',
  border: '#eef0f5',
  green: '#10b981',
  red: '#ea4335',
};

const S = {
  wrapper: {
    minHeight: '100vh',
    fontFamily: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
    background: C.bg,
  },
  header: {
    background: `linear-gradient(135deg,${C.pri} 0%,#111c4e 50%,#1a2f7a 100%)`,
    padding: 'clamp(32px,5vw,48px) clamp(16px,4vw,20px) clamp(48px,8vw,64px)',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  backBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    color: 'rgba(255,255,255,0.70)',
    textDecoration: 'none',
    fontSize: '14px',
    cursor: 'pointer',
    position: 'relative',
    zIndex: 1,
    marginBottom: '24px',
    background: 'none',
    border: 'none',
    padding: '8px 4px',
    minHeight: '44px',
    minWidth: '44px',
  },
  h1: {
    fontSize: 'clamp(24px,4vw,44px)',
    fontWeight: 800,
    color: C.white,
    margin: '0 0 12px',
    position: 'relative',
    zIndex: 1,
  },
  sub: {
    fontSize: 'clamp(14px,1.8vw,16px)',
    color: 'rgba(255,255,255,0.55)',
    maxWidth: '600px',
    margin: '0 auto',
    lineHeight: 1.7,
    position: 'relative',
    zIndex: 1,
    padding: '0 16px',
  },
  body: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: 'clamp(32px,5vw,48px) clamp(16px,4vw,20px) 80px',
  },
  card: {
    background: C.white,
    borderRadius: 'clamp(12px,2vw,16px)',
    padding: 'clamp(20px,4vw,32px)',
    border: `1px solid ${C.border}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
    marginBottom: 'clamp(16px,2vw,24px)',
  },
  h2: { fontSize: 'clamp(18px,2.5vw,22px)', fontWeight: 700, color: C.pri, margin: '0 0 8px' },
  cardText: { fontSize: 'clamp(14px,1.6vw,15px)', color: C.muted, lineHeight: 1.7 },
  toggleGroup: {
    display: 'inline-flex',
    background: C.bg,
    borderRadius: '10px',
    padding: '3px',
    border: `1px solid ${C.border}`,
    marginBottom: '20px',
  },
  toggleBtn: (act) => ({
    padding: '8px 18px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    background: act ? C.pri2 : 'transparent',
    color: act ? C.white : C.muted,
    transition: 'all 0.2s',
    minHeight: '40px',
  }),
  planGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%,220px), 1fr))',
    gap: 'clamp(12px,2vw,16px)',
    marginTop: '24px',
  },
  planCard: (destacado) => ({
    background: destacado ? `linear-gradient(135deg,${C.pri} 0%,#111c4e 100%)` : C.white,
    borderRadius: 'clamp(12px,2vw,16px)',
    padding: 'clamp(16px,2vw,24px)',
    border: destacado ? `2px solid ${C.accent}` : `1px solid ${C.border}`,
    boxShadow: destacado ? `0 8px 32px ${C.accent}30` : '0 1px 3px rgba(0,0,0,0.04)',
    textAlign: 'center',
    transition: 'all 0.3s',
    cursor: 'pointer',
  }),
  planSedes: { fontSize: '13px', color: C.accent, fontWeight: 600, marginBottom: '4px' },
  planPrice: (d) => ({
    fontSize: 'clamp(28px,3.5vw,36px)',
    fontWeight: 800,
    color: d ? C.white : C.pri,
    margin: '4px 0',
  }),
  planMonth: (d) => ({ fontSize: '13px', color: d ? 'rgba(255,255,255,0.5)' : C.muted }),
  planAhorro: {
    fontSize: '12px',
    color: C.green,
    fontWeight: 700,
    marginTop: '8px',
    padding: '4px 10px',
    background: '#ecfdf5',
    borderRadius: '6px',
    display: 'inline-block',
  },
  planFeatures: { listStyle: 'none', padding: '0', margin: '16px 0 0', textAlign: 'left' },
  planFeature: (d) => ({
    fontSize: '13px',
    color: d ? 'rgba(255,255,255,0.7)' : C.muted,
    padding: '6px 0',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    lineHeight: 1.4,
  }),
  highlight: {
    background: '#fffbeb',
    borderRadius: '12px',
    padding: 'clamp(16px,2vw,20px)',
    border: '1px solid #fde68a',
  },
  highlightTitle: {
    fontSize: 'clamp(15px,1.8vw,16px)',
    fontWeight: 700,
    color: '#92400e',
    margin: '0 0 8px',
  },
  highlightText: { fontSize: 'clamp(13px,1.5vw,14px)', color: '#78350f', lineHeight: 1.7 },
  tableWrapper: { overflowX: 'auto', WebkitOverflowScrolling: 'touch', marginTop: '20px' },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 'clamp(13px,1.4vw,14px)',
    minWidth: '500px',
  },
  th: {
    textAlign: 'left',
    padding: '10px 14px',
    borderBottom: `2px solid ${C.border}`,
    color: C.pri,
    fontWeight: 700,
  },
  td: { padding: '10px 14px', borderBottom: `1px solid ${C.border}`, color: C.text },
  tr: (even) => ({ background: even ? C.bg : C.white }),
  grid2: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%,280px), 1fr))',
    gap: 'clamp(12px,2vw,16px)',
    marginTop: '20px',
  },
  miniCard: {
    background: C.bg,
    borderRadius: '12px',
    padding: 'clamp(16px,2vw,20px)',
    border: `1px solid ${C.border}`,
  },
  miniH3: { fontSize: 'clamp(14px,1.6vw,16px)', fontWeight: 700, color: C.pri, margin: '0 0 6px' },
  miniP: { fontSize: 'clamp(13px,1.4vw,14px)', color: C.muted, lineHeight: 1.6 },
  trialCard: {
    background: 'linear-gradient(135deg,#ecfdf5,#f0fdf4)',
    borderRadius: '16px',
    padding: 'clamp(20px,3vw,32px)',
    border: '2px solid #a7f3d0',
    marginBottom: '24px',
  },
  trialBadge: {
    display: 'inline-block',
    background: C.green,
    color: C.white,
    padding: '4px 14px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 700,
    marginBottom: '16px',
  },
  trialFlow: {
    background: '#064e3b',
    borderRadius: '14px',
    padding: 'clamp(16px,2vw,28px)',
    color: C.white,
    marginTop: '16px',
  },
};

const TIPOS = [
  {
    key: 'interno',
    titulo: 'Inventario Interno',
    desc: 'Gestion manual desde Agorax',
    planes: [
      { s: '1 Sede', p: 30 },
      { s: '2 Sedes', p: 55 },
      { s: '3 Sedes', p: 80 },
      { s: '4 Sedes', p: 100 },
      { s: '5 Sedes', p: 110 },
    ],
    descuentos: { mensual: 0, trimestral: 10, semestral: 20, anual: 40 },
    grad: `linear-gradient(135deg,${C.pri} 0%,#111c4e 100%)`,
  },
  {
    key: 'externo',
    titulo: 'Inventario Externo',
    desc: 'Sincronizado con tu sistema',
    planes: [
      { s: '1 Sede', p: 30 },
      { s: '2 Sedes', p: 55 },
      { s: '3 Sedes', p: 80 },
      { s: '4 Sedes', p: 100 },
      { s: '5 Sedes', p: 110 },
    ],
    descuentos: { mensual: 0, trimestral: 10, semestral: 20, anual: 40 },
    grad: `linear-gradient(135deg,${C.pri} 0%,#111c4e 100%)`,
  },
];

const PAQUETES_IA = [
  { p: '$2 USD', c: '$0.12', t: '$2.12' },
  { p: '$5 USD', c: '$0.30', t: '$5.30' },
  { p: '$10 USD', c: '$0.60', t: '$10.60', rec: true },
  { p: '$20 USD', c: '$1.20', t: '$21.20' },
  { p: '$50 USD', c: '$3.00', t: '$53.00' },
  { p: '$100 USD', c: '$6.00', t: '$106.00' },
  { p: '$500 USD', c: '$30.00', t: '$530.00' },
];

function PreciosDetalle() {
  const nav = useNavigate();
  const [periodo, setPeriodo] = useState('mensual');

  const periodos = {
    mensual: { label: 'Mensual', mult: 1 },
    trimestral: { label: 'Trimestral', mult: 3 },
    semestral: { label: 'Semestral', mult: 6 },
    anual: { label: 'Anual', mult: 12 },
  };
  const p = periodos[periodo];

  return (
    <div style={S.wrapper}>
      <style>
        {
          'body{overflow:auto!important}@media(max-width:768px){.precios-cols{grid-template-columns:1fr!important}}'
        }
      </style>
      <div style={S.header}>
        <button onClick={() => nav('/#planes')} style={S.backBtn} aria-label="Volver al inicio">
          &#8592; Volver al inicio
        </button>
        <h1 style={S.h1}>Planes, Convenio y Costos</h1>
        <p style={S.sub}>Precios transparentes, sin letra chica. Paga solo por lo que usas.</p>
      </div>
      <div style={S.body}>
        {/* Convenio / Trial */}
        <div style={S.trialCard}>
          <div style={{ textAlign: 'center' }}>
            <div style={S.trialBadge}>Convenio de Inicio</div>
            <h2 style={{ ...S.h2, marginBottom: '12px' }}>15 Dias de Prueba Gratuita</h2>
            <p style={S.cardText}>
              Recibe tu empresa completamente configurada con las opciones básicas: alta de empresa,
              creación de sede principal, carga de catálogo inicial y configuración del bot IA con
              tu nombre y personalidad.
            </p>
          </div>
          <div style={S.trialFlow}>
            <div
              style={{
                display: 'flex',
                gap: 'clamp(16px,3vw,32px)',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div style={{ textAlign: 'center', maxWidth: '300px' }}>
                <div
                  style={{ fontSize: 'clamp(14px,1.5vw,15px)', opacity: 0.7, marginBottom: '4px' }}
                >
                  Al finalizar la prueba gratuita
                </div>
                <div
                  style={{
                    fontSize: 'clamp(22px,3vw,28px)',
                    fontWeight: 900,
                    lineHeight: 1.2,
                  }}
                >
                  Configuración + 1ra mensualidad
                </div>
                <div style={{ fontSize: 'clamp(11px,1.2vw,12px)', opacity: 0.6, marginTop: '4px' }}>
                  El costo por configuración se cobra junto con la primera mensualidad
                </div>
              </div>
              <div style={{ fontSize: 'clamp(24px,3vw,32px)', opacity: 0.4 }}>&#8594;</div>
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{ fontSize: 'clamp(14px,1.5vw,15px)', opacity: 0.7, marginBottom: '4px' }}
                >
                  Meses siguientes
                </div>
                <div style={{ fontSize: 'clamp(36px,5vw,48px)', fontWeight: 900 }}>$30</div>
                <div style={{ fontSize: 'clamp(11px,1.2vw,12px)', opacity: 0.6, marginTop: '4px' }}>
                  Por mes (1 sede)
                </div>
              </div>
            </div>
            <p
              style={{
                fontSize: 'clamp(12px,1.3vw,13px)',
                opacity: 0.65,
                textAlign: 'center',
                margin: '12px 0 0',
                lineHeight: 1.5,
              }}
            >
              Al finalizar los 14 días de prueba gratuita se cobra el costo por configuración junto
              con la primera mensualidad. Luego queda pagando la mensualidad regular según la
              cantidad de sedes.
            </p>
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Planes por Sede</h2>
          <p style={S.cardText}>
            El pago por uso del sistema es por sede. Ambos tipos de inventario tienen el mismo
            precio. Cada sede tiene su propio inventario, métodos de pago, usuarios y configuración
            de IA.
          </p>

          <div style={{ textAlign: 'center' }}>
            <div style={S.toggleGroup}>
              {Object.entries(periodos).map(([k, v]) => (
                <button key={k} style={S.toggleBtn(periodo === k)} onClick={() => setPeriodo(k)}>
                  {v.label}
                </button>
              ))}
            </div>
          </div>

          <div
            className="precios-cols"
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '20px',
              marginTop: '24px',
            }}
          >
            {TIPOS.map((tipo) => {
              const periodoLabel =
                p.mult === 1 ? '/mes' : periodo === 'anual' ? '/año' : `/${p.mult} meses`;
              return (
                <div
                  key={tipo.key}
                  style={{
                    background: C.white,
                    borderRadius: '16px',
                    border: `1px solid ${C.border}`,
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  }}
                >
                  <div style={{ background: tipo.grad, padding: '16px 20px' }}>
                    <div style={{ fontSize: '17px', fontWeight: 800, color: C.white }}>
                      {tipo.titulo}
                    </div>
                    <div
                      style={{
                        fontSize: '13px',
                        color: 'rgba(255,255,255,0.65)',
                        marginTop: '2px',
                      }}
                    >
                      {tipo.desc}
                    </div>
                  </div>
                  <div style={{ padding: '12px 20px 20px' }}>
                    {tipo.planes.map((pl, i) => {
                      const total = pl.p * p.mult - tipo.descuentos[periodo];
                      return (
                        <div
                          key={i}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '11px 0',
                            borderBottom: i < 4 ? `1px solid ${C.border}` : 'none',
                          }}
                        >
                          <span style={{ fontSize: '14px', color: C.text, fontWeight: 500 }}>
                            {pl.s}
                          </span>
                          <div>
                            <span style={{ fontSize: '22px', fontWeight: 800, color: C.pri }}>
                              ${total}
                            </span>
                            <span style={{ fontSize: '11px', color: C.muted, marginLeft: '3px' }}>
                              {periodoLabel}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                    <div
                      style={{
                        padding: '10px 0 0',
                        fontSize: '13px',
                        color: C.accent,
                        fontWeight: 600,
                        fontStyle: 'italic',
                      }}
                    >
                      +$10 por cada sede adicional
                    </div>
                    {tipo.descuentos[periodo] > 0 && (
                      <div
                        style={{
                          background: '#ecfdf5',
                          borderRadius: '8px',
                          padding: '7px 12px',
                          textAlign: 'center',
                          marginTop: '10px',
                        }}
                      >
                        <span style={{ fontSize: '13px', fontWeight: 700, color: C.green }}>
                          Ahorras ${tipo.descuentos[periodo]}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Que Incluye la Licencia</h2>
          <div style={S.grid2}>
            {[
              {
                t: 'Bot IA configurable',
                d: 'Skills, temperatura, prompt personalizado, cache inteligente. Sin costo adicional de IA.',
              },
              {
                t: '9 métodos de pago',
                d: 'Efectivo USD/BS/COP, Binance, PayPal, Zelle, Pago Móvil, Transferencia, Nequi.',
              },
              {
                t: 'POS multi-moneda',
                d: 'Punto de venta con cierres de caja, arqueo, descuentos y recibos.',
              },
              {
                t: 'Asistencia QR',
                d: 'Control de asistencia del personal con códigos QR por sede. Reportes y justificaciones.',
              },
              {
                t: 'Sincronización externa',
                d: 'Conexión a SQL Server, PostgreSQL, MySQL o Firebird via agente de escritorio.',
              },
              {
                t: 'Panel admin y roles',
                d: 'Admin, supervisor, asesor, armador, delivery. Permisos granulares RBAC.',
              },
              {
                t: 'Delivery y armado',
                d: 'Panel Kanban, optimización de rutas, checklist de armado persistente.',
              },
              {
                t: 'Soporte incluido',
                d: 'Atención por chat, teléfono y correo. Respuesta en menos de 24h hábiles.',
              },
            ].map((x, i) => (
              <div key={i} style={S.miniCard}>
                <h3 style={S.miniH3}>{x.t}</h3>
                <p style={S.miniP}>{x.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Costo de la Inteligencia Artificial</h2>
          <p style={S.cardText}>
            Cada empresa asigna su propia API Key de IA (DeepSeek u otro proveedor). La empresa es
            responsable de mantener saldo activo en su cuenta de IA. Agorax no obtiene ganancias por
            este concepto. El saldo es acumulable y no vence mientras se use el sistema.
          </p>

          <div style={S.highlight}>
            <div style={S.highlightTitle}>Cómo funciona el consumo</div>
            <p style={S.highlightText}>
              Con <strong>10,000 mensajes</strong> procesados por la IA se atienden aproximadamente{' '}
              <strong>1,500 interacciones</strong> con clientes, equivalente a{' '}
              <strong>200-250 clientes activos al mes</strong>. Considerando que cada cliente hace
              2-3 compras, el costo total operativo para atender a esa cantidad de clientes es de
              solo <strong>$3 USD al mes</strong>.
            </p>
          </div>

          <div
            style={{
              ...S.highlight,
              marginTop: '16px',
              background: '#ecfdf5',
              border: '1px solid #a7f3d0',
            }}
          >
            <div style={{ ...S.highlightTitle, color: C.green }}>El secreto: Cache Inteligente</div>
            <p style={{ ...S.highlightText, color: '#064e3b' }}>
              Preguntas repetitivas como "¿cuánto cuesta?", "gracias", "¿qué horario tienen?",
              "confirmar pedido" se guardan en cache y se responden sin llamar a la IA. En una
              conversación típica de 7 mensajes, 2-3 ya están en cache (costo $0). Por eso el gasto
              real es mucho menor de lo que parece.
            </p>
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Paquetes de Recarga</h2>
          <p style={S.cardText}>
            Recargas directas a la API de IA. El saldo no vence mientras uses Agorax. Comisión de 6%
            sobre el monto de recarga.
          </p>
          <div style={S.tableWrapper}>
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>Recarga</th>
                  <th style={S.th}>Comisión (6%)</th>
                  <th style={S.th}>Total a Pagar</th>
                </tr>
              </thead>
              <tbody>
                {PAQUETES_IA.map((r, i) => (
                  <tr
                    key={i}
                    style={{
                      background: r.rec ? '#fef3c7' : S.tr(i % 2 === 0).background,
                      fontWeight: r.rec ? 700 : 'normal',
                    }}
                  >
                    <td style={{ ...S.td, fontWeight: r.rec ? 700 : 'normal' }}>{r.p}</td>
                    <td style={S.td}>{r.c}</td>
                    <td
                      style={{
                        ...S.td,
                        fontWeight: r.rec ? 700 : 'normal',
                        color: r.rec ? C.pri2 : 'inherit',
                      }}
                    >
                      {r.t}{' '}
                      {r.rec && (
                        <span
                          style={{
                            fontSize: '11px',
                            color: C.green,
                            fontWeight: 700,
                            marginLeft: '6px',
                          }}
                        >
                          {'Recomendado'}
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Formas de Pago de la Licencia</h2>
          <div style={S.grid2}>
            {[
              {
                t: 'USDT (Binance)',
                d: 'Transferencia en USDT via Binance. Rapido y sin intermediarios.',
              },
              {
                t: 'Dolares en Efectivo',
                d: 'Pago en dolares americanos en efectivo. Aplica para pagos presenciales.',
              },
              {
                t: 'Bolivares',
                d: 'Calculado a la tasa del USDT del dia del pago. Pago Movil o transferencia.',
              },
            ].map((x, i) => (
              <div key={i} style={S.miniCard}>
                <h3 style={S.miniH3}>{x.t}</h3>
                <p style={S.miniP}>{x.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div style={S.card}>
          <h2 style={S.h2}>Condiciones</h2>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {[
              {
                icon: '\u2705',
                t: 'Sin letra chica',
                d: 'Precios transparentes. Lo que ves es lo que pagas.',
              },
              {
                icon: '\uD83D\uDD04',
                t: 'Sin penalizaciones',
                d: 'Si no pagas, el sistema se desactiva automáticamente. Sin multas ni intereses. Se reactiva en menos de 24h hábiles tras el pago.',
              },
              {
                icon: '\uD83D\uDCB0',
                t: 'Sin reembolso',
                d: 'Si pagas por adelantado y decides cancelar, no hay reembolso. Pero puedes usar Agorax hasta el último día pagado.',
              },
              {
                icon: '\u2696',
                t: 'Saldo acumulable',
                d: 'El saldo de IA no vence mientras uses Agorax. Si no lo consumes este mes, se acumula para el siguiente. El cliente es responsable de mantener saldo activo.',
              },
              {
                icon: '\uD83D\uDCC5',
                t: 'Flexibilidad',
                d: 'Puedes cambiar de plan en cualquier momento. Solo pagas la diferencia.',
              },
              {
                icon: '\uD83D\uDCBB',
                t: 'Costo por configuración',
                d: 'Se cobra al finalizar la prueba gratuita, junto con la primera mensualidad. Independientemente del plan elegido.',
              },
            ].map((li, i) => (
              <li
                key={i}
                style={{
                  ...S.cardText,
                  padding: '8px 0',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '10px',
                }}
              >
                <span style={{ fontSize: '18px', flexShrink: 0 }}>{li.icon}</span>
                <div style={{ flex: 1 }}>
                  <strong style={{ color: C.pri }}>{li.t}</strong>
                  <p style={{ margin: '2px 0 0', fontSize: '13px' }}>{li.d}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <button
          onClick={() => nav('/#planes')}
          style={{
            ...S.backBtn,
            color: C.pri2,
            display: 'block',
            margin: '0 auto',
            fontSize: 'clamp(14px,1.6vw,16px)',
            fontWeight: 600,
          }}
          aria-label="Volver al inicio"
        >
          &#8592; Volver al inicio
        </button>
      </div>
    </div>
  );
}

export default PreciosDetalle;
